(function ($) {
  "use strict";
  $(function () {
    let $promoCodeSuccess = $(document).find('#promoCodeSuccess');
    let $promoCodeNoActive = $(document).find('#promoCodeNoActive');
    let $promoCodeNoPrice = $(document).find('#promoCodeNoPrice');
    if ($promoCodeSuccess.length) {
      $promoCodeSuccess.on('closed.zf.reveal', function () {
        window.location.reload();
      });
    }

    $(document).on('click', '[data-entity="promocode-button"]', function (e) {
      let data = new FormData();
      let value = $(document).find('#promocode-value').val();
      let action = $(this).data('action');
      data.append('sessid', $(this).data('sessid'));
      data.append('action', action);
      data.append('value', value);
      if (value.length === 0) {
        showError('Промокод не введен')
      } else {
        hideError();
        $.ajax({
          method: 'POST',
          url: '/ajax/promocode.php',
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (data) {
            if (data.result) {
              if (action === "apply") {
                if ($promoCodeSuccess.length) {
                  $promoCodeSuccess.foundation('open');
                }
              } else {
                window.location.reload();
              }
            } else if (data.resultNoActive) {
              if (action === "apply") {
                if ($promoCodeNoActive.length) {
                  $promoCodeNoActive.foundation('open');
                }
              } else {
                window.location.reload();
              }
            } else if (data.resultNoPrice) {
              if (action === "apply") {
                if ($promoCodeNoPrice.length) {
                  $promoCodeNoPrice.foundation('open');
                }
              } else {
                window.location.reload();
              }
            } else {
              showError(data)
            }
          },
          error: function (data) {
            showError('Ошибка. Купон не применен.');
          }
        });
      }

      return true;
    });

    function showError(str) {
      let $message = $(document).find('[data-entity="promocode-message"]');
      if ($message.length) {
        $message.text(str);
        $message.fadeIn(200, function () {
        });
      }
    }

    function hideError() {
      let $message = $(document).find('[data-entity="promocode-message"]');
      if ($message.length) {
        $message.fadeOut(200, function () {
          $message.text('');
        });
      }
    }
  })
})(jQuery);
